import React, { useState } from "react";
import { Output } from "../../Text";
import {
  Button,
  ContentSection,
  PageWrap,
  ButtonContainer,
  Paragraph,
  Spinner,
  Checkbox,
} from "@vwfs-bronson/bronson-react";
import Icon, { IconSize } from "../Icon";
import { startApplication } from "../../services/api/storeData/storeBasicAppFormData";
import { Analytics } from "../../services/analytics";
import { isVtiBOP } from "../../common/JourneyType";

const BoniLanding = ({
  transactionId,
  onContinue,
  originSystem,
  vehicleData,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [deviationsPurchasedItemConsent, setDeviationsPurchasedItemConsent] = useState(false);
  const [reductionLimitationPeriodConsent, setReductionLimitationPeriodConsent] = useState(false);

  const onWeiter = async () => {
    const dataPrivacyConsent = {
      deviationsPurchasedItemConsent: deviationsPurchasedItemConsent,
      reductionLimitationPeriodConsent: reductionLimitationPeriodConsent
    }
    const hasDataPrivacyConstent = deviationsPurchasedItemConsent && reductionLimitationPeriodConsent ? true : false
    setIsLoading(true);
    startApplication(transactionId, hasDataPrivacyConstent ? dataPrivacyConsent : undefined).finally(() => {
      setIsLoading(false);
      onContinue();
    });
  };
  const pageName = "Landing page";

  const defaultTrackingData = {
    [Analytics.keys.pageName()]: pageName,
    [Analytics.keys.viewChange()]: pageName,
    [Analytics.keys.eventType(0)]: "pageView",
    [Analytics.keys.eventAction(0)]: "Success",
    [Analytics.keys.eventType(1)]: "Product journey",
    [Analytics.keys.eventAction(1)]: "Start",
    [Analytics.keys.eventType(2)]: "Product configuration",
    [Analytics.keys.eventAction(2)]: "Completed",
    [Analytics.keys.eventType(3)]: "Product price",
    [Analytics.keys.eventAction(3)]: "Calculated",
  };

  const trackPage = () => {
    setTimeout(() => {
      Analytics.setTrackingData(defaultTrackingData);
      Analytics.trackPage();
    }, 1500);
  };

  React.useEffect(() => {
    trackPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  const buildVtiTextLink = () => {
    return (
      <a
        href={
          vehicleData?.appraisals &&
          vehicleData?.appraisals.length > 0 &&
          vehicleData?.appraisals[0].url
        }
        target="_blank"
        rel="noopener noreferrer"
      >
        {Output.resolve(
          "pages.boniLanding.vti.deviationsPurchasedItemConsent.linkText"
        )}
      </a>
    );
  };

  const renderContentVti = () => {
    return (
      <>
        <Paragraph className="u-mt u-mb">
          <Checkbox
            name="deviationsPurchasedItemConsentCheck"
            id="deviationsPurchasedItemConsentCheck"
            testid="deviationsPurchasedItemConsentCheck"
            checked={deviationsPurchasedItemConsent}
            onChange={(e) => {
              setDeviationsPurchasedItemConsent(!deviationsPurchasedItemConsent);
            }}
          >
            {Output.resolve(
              "pages.boniLanding.vti.deviationsPurchasedItemConsent.checkboxLabel"
            )}
          </Checkbox>
        </Paragraph>
        <Paragraph>
          {Output.resolve(
            "pages.boniLanding.vti.deviationsPurchasedItemConsent.text"
          )}
          {buildVtiTextLink()}
          {Output.resolve(
            "pages.boniLanding.vti.deviationsPurchasedItemConsent.textFullStop"
          )}
        </Paragraph>

        <Paragraph className="u-mt u-mb">
          <Checkbox
            name="reductionLimitationPeriodConsent"
            id="reductionLimitationPeriodConsent"
            testid="reductionLimitationPeriodConsent"
            checked={reductionLimitationPeriodConsent}
            onChange={(e) => {
              setReductionLimitationPeriodConsent(!reductionLimitationPeriodConsent);
            }}
          >
            {Output.resolve(
              "pages.boniLanding.vti.reductionLimitationPeriodConsent.checkboxLabel"
            )}
          </Checkbox>
        </Paragraph>
        <Paragraph>
          {Output.resolve(
            "pages.boniLanding.vti.reductionLimitationPeriodConsent.text"
          )}
        </Paragraph>
      </>
    );
  };

  const disableVtiButton = () => {
    return !deviationsPurchasedItemConsent || !reductionLimitationPeriodConsent;
  };

  const renderContent = () => {
    return (
      <>
        <Paragraph className="u-mt-large">
          {Output.resolve("pages.boniLanding.text")}
        </Paragraph>
        {isVtiBOP(originSystem) && renderContentVti()}
        <ButtonContainer center className="u-mt-xlarge">
          <Button
            className="appFixedButton"
            onClick={onWeiter}
            disabled={isVtiBOP(originSystem) ? disableVtiButton() : false}
          >
            {isLoading ? (
              <Spinner section center small />
            ) : (
              Output.resolve("pages.boniLanding.button")
            )}
          </Button>
        </ButtonContainer>
      </>
    );
  };

  return (
    <>
      <ContentSection pale className="u-pt-none">
        <PageWrap>
          <div className="u-text-center">
            <Icon icon={"semantic-checkmark"} size={IconSize.XxLarge} />
            <h3>{Output.resolveAsMarkdown("pages.boniLanding.title")}</h3>
          </div>
          {renderContent()}
        </PageWrap>
      </ContentSection>
    </>
  );
};

export default BoniLanding;
